const GOOGLE_MAPS_API_KEY = 'AIzaSyCaMtih5UqeAP7MAGclyi2xGaPLIhFc9QA'

let mapsLoadPromise = null

const toCoordinateNumber = value => {
	if (value === '' || value == null) return null
	const parsed = Number(value)
	return Number.isFinite(parsed) ? parsed : null
}

export const ensureGoogleMapsLoaded = () => {
	if (window.google?.maps?.importLibrary) {
		return Promise.resolve(window.google.maps)
	}

	if (mapsLoadPromise) return mapsLoadPromise

	mapsLoadPromise = new Promise((resolve, reject) => {
		const finish = () => {
			if (window.google?.maps?.importLibrary) {
				resolve(window.google.maps)
				return
			}
			reject(new Error('Google Maps importLibrary unavailable'))
		}

		if (window.google?.maps?.importLibrary) {
			finish()
			return
		}

		const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')
		if (existingScript) {
			existingScript.addEventListener('load', finish)
			existingScript.addEventListener('error', () => reject(new Error('Failed to load Google Maps')))
			const pollId = window.setInterval(() => {
				if (window.google?.maps?.importLibrary) {
					window.clearInterval(pollId)
					finish()
				}
			}, 50)
			window.setTimeout(() => {
				window.clearInterval(pollId)
				if (!window.google?.maps?.importLibrary) {
					reject(new Error('Timed out waiting for Google Maps'))
				}
			}, 10000)
			return
		}

		const callbackName = `__onGoogleMapsRoutesReady_${Date.now()}`
		window[callbackName] = () => {
			delete window[callbackName]
			finish()
		}

		const script = document.createElement('script')
		script.async = true
		script.defer = true
		script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&callback=${callbackName}&v=weekly&loading=async`
		script.onerror = () => reject(new Error('Failed to load Google Maps'))
		document.head.appendChild(script)
	}).catch(error => {
		mapsLoadPromise = null
		throw error
	})

	return mapsLoadPromise
}

export const fetchGoogleDrivingDistanceKm = async (fromLat, fromLong, toLat, toLong) => {
	const originLat = toCoordinateNumber(fromLat)
	const originLong = toCoordinateNumber(fromLong)
	const destinationLat = toCoordinateNumber(toLat)
	const destinationLong = toCoordinateNumber(toLong)

	if (
		originLat == null
		|| originLong == null
		|| destinationLat == null
		|| destinationLong == null
	) {
		return null
	}

	await ensureGoogleMapsLoaded()

	const { Route } = await window.google.maps.importLibrary('routes')
	if (!Route?.computeRoutes) {
		throw new Error('Google Routes API (Route.computeRoutes) is unavailable')
	}

	const { routes } = await Route.computeRoutes({
		origin: { lat: originLat, lng: originLong },
		destination: { lat: destinationLat, lng: destinationLong },
		travelMode: 'DRIVING',
		fields: ['distanceMeters'],
	})

	const meters = routes?.[0]?.distanceMeters
	if (meters == null || !Number.isFinite(Number(meters))) {
		throw new Error('Google Routes API returned no distance')
	}

	return Math.round((Number(meters) / 1000) * 100) / 100
}
